import React from 'react';
import Marquee from 'react-fast-marquee';
import styled from 'styled-components';

const MarqueeText = styled.h3`
	width: max-content;
	margin: 15px 30px;
	color: #deded0;
`;

const TextMarquee = ({list, direction = 'right'}) => {
	return (
		<Marquee speed="50" direction={direction}>
			{list.map((item, index) => (
				<MarqueeText key={index}>{item}</MarqueeText>
			))}
		</Marquee>
	);
};

export default TextMarquee;
